import { call } from 'redux-saga/effects'
import { optimisticPut } from 'utils/sagas'
import { action as apiAction } from 'api/Api'
import {
  positionLayoutGroup
} from '../redux/layouts'

export default function * requestPositionLayoutGroup (action) {
  const { layoutId, id, position } = action.payload

  const optimisticAction = yield optimisticPut(positionLayoutGroup({
    layoutId,
    layoutGroupId: id,
    position
  }))

  try {
    yield call(apiAction, 'PositionLayoutGroup', {
      layoutId,
      groupId: id,
      position
    })

    yield optimisticAction.commit()
  } catch (error) {
    yield optimisticAction.revert()

    throw error
  }
}
